'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["buttonRef", "options"];
import PropTypes from 'prop-types';
import { createRef, PureComponent } from 'react';
import UIDropdown from './UIDropdown';
import omit from '../utils/underscore/omit';
import { isPageInKeyboardMode } from '../listeners/focusStylesListener';
import Controllable from '../decorators/Controllable';
import { renderMenu } from './utils/renderMultiLevelMenu';
import { jsx as _jsx } from "react/jsx-runtime";
class UIMultiLevelDropdown extends PureComponent {
  constructor(...args) {
    super(...args);
    this.buttonRef = /*#__PURE__*/createRef();
    this.renderMenu = () => {
      const {
        options
      } = this.props;
      return renderMenu(options);
    };
  }
  componentDidUpdate(prevProps) {
    const {
      buttonRef,
      open
    } = this.props;
    // UIDropown will focus the button for us if the user selects an option from the root dropdown,
    // but we need to handle the case where the user selects a *nested* option with the keyboard.
    if (prevProps.open === true && open === false && isPageInKeyboardMode()) {
      (buttonRef || this.buttonRef).current.focus();
    }
  }
  render() {
    const _this$props = this.props,
      {
        buttonRef
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx(UIDropdown, Object.assign({}, rest, {
      animateOnToggle: false,
      buttonRef: buttonRef || this.buttonRef,
      Content: this.renderMenu
    }));
  }
}
UIMultiLevelDropdown.propTypes = Object.assign({}, omit(UIDropdown.propTypes, ['animateOnMount', 'animateOnToggle', 'Content']), {
  options: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape({
    label: PropTypes.node,
    selected: PropTypes.bool,
    options: PropTypes.oneOfType([PropTypes.array, PropTypes.node])
  }), PropTypes.node, PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.node,
    selected: PropTypes.bool,
    options: PropTypes.oneOfType([PropTypes.array, PropTypes.node])
  }))])).isRequired
});
UIMultiLevelDropdown.defaultProps = Object.assign({}, UIDropdown.defaultProps);
UIMultiLevelDropdown.displayName = 'UIMultiLevelDropdown';
export default Controllable(UIMultiLevelDropdown, ['open']);